import { ChangeDetectionStrategy, Component, input } from '@angular/core';
import { NgOptimizedImage } from '@angular/common';
import {
  getColumnKey,
  ImageThumbnailComponent,
  ImageThumbnailUnsupportedComponent,
  NoDataComponent,
  TableBodyNoReferenceCellComponent,
  TableColumn,
} from '@web/shared/ui';
import { AdminBoxCollectionItem } from '../../models/admin-box-collection-item';
import { isNotNil } from '@web/utils';
import { AdminBoxCollectionFilter } from '../../models/admin-box-collection-filter';
import { AdminBoxStatusComponent } from '../admin-box-status/admin-box-status.component';
import { AdminBoxLinkComponent } from '../admin-box-link/admin-box-link.component';

@Component({
  selector: 'app-admin-box-list-custom-cell-template',
  imports: [
    ImageThumbnailComponent,
    ImageThumbnailUnsupportedComponent,
    NgOptimizedImage,
    NoDataComponent,
    TableBodyNoReferenceCellComponent,
    AdminBoxStatusComponent,
    AdminBoxLinkComponent,
  ],
  templateUrl: './admin-box-list-custom-cell-template.component.html',
  styleUrl: './admin-box-list-custom-cell-template.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AdminBoxListCustomCellTemplateComponent {
  /* prettier-ignore */
  public readonly column = input.required<TableColumn<AdminBoxCollectionItem, AdminBoxCollectionFilter>>();
  /* prettier-ignore */
  public readonly model = input.required<AdminBoxCollectionItem>();

  protected readonly getColumnKey = getColumnKey<AdminBoxCollectionItem>;
  protected readonly isNotNil = isNotNil;
}
